<div class="controls d-none d-sm-flex" role="group" [attr.aria-label]="'panzoom.zoomControls' | translate">
  <button class="btn" id="btn-zoom-in" (click)="onZoom('in')" [disabled]="panZoomService.isZoomInDisabled"
          [attr.aria-label]="'panzoom.zoomIn' | translate">
    <i class="icon icon-plus" aria-hidden="true"></i>
  </button>
  <button class="btn" id="btn-zoom-out" (click)="onZoom('out')" [disabled]="panZoomService.isZoomOutDisabled"
          [attr.aria-label]="'panzoom.zoomOut' | translate">
    <i class="icon icon-minus" aria-hidden="true"></i>
  </button>
</div>
<div class="controls d-flex d-sm-none" role="group" [attr.aria-label]="'panzoom.zoomControls' | translate">
  <button class="btn" id="btn-zoom-out-mobile" (click)="onZoom('out')" [disabled]="panZoomService.isZoomOutDisabled"
          [attr.aria-label]="'panzoom.zoomOut' | translate">
    <i class="icon icon-zoom-out" aria-hidden="true"></i>
  </button>
</div>

<div class="area-out">
  <div #viewerContainer class="area-in viewer-container">
    <div #mainView class="main-view" (scroll)="onScroll()">
      <div #mainContent class="zoom-content">
        <ng-container *ngIf="customContent" [ngTemplateOutlet]="customContent"></ng-container>
      </div>
    </div>
  </div>

  <button id="btn-move-up" class="nav-button up" *ngIf="panZoomService.showTopChevron" (click)="onMove('up')"
          [attr.aria-label]="'panzoom.moveUp' | translate">
    <i class="icon icon-chevron-up" aria-hidden="true"></i>
  </button>
  <button id="btn-move-left" class="nav-button left" *ngIf="panZoomService.showLeftChevron" (click)="onMove('left')"
          [attr.aria-label]="'panzoom.moveLeft' | translate">
    <i class="icon icon-chevron-left" aria-hidden="true"></i>
  </button>
  <button id="btn-move-right" class="nav-button right" *ngIf="panZoomService.showRightChevron" (click)="onMove('right')"
          [attr.aria-label]="'panzoom.moveRight' | translate">
    <i class="icon icon-chevron-right" aria-hidden="true"></i>
  </button>
  <button id="btn-move-down" class="nav-button down" *ngIf="panZoomService.showBottomChevron" (click)="onMove('down')"
          [attr.aria-label]="'panzoom.moveDown' | translate">
    <i class="icon icon-chevron-down" aria-hidden="true"></i>
  </button>
</div>

<div class="area-preview" [class.active]="panZoomService.zoomLevel > 1" aria-hidden="true">
  <label *ngIf="!customMiniatureHeader; else customMiniatureHeader"
         class="miniature-header">{{ 'panzoom.miniature.youAreHere' | translate }}</label>

  <div class="miniature">
    <div #miniView class="mini-view" style="pointer-events: none">
      <div #miniContent class="zoom-content" style="pointer-events: none">
        <!-- <ng-container *ngIf="panZoomService.miniatureRendered"> -->
        <ng-container *ngIf="customMiniatureContent" [ngTemplateOutlet]="customMiniatureContent"></ng-container>
        <!-- </ng-container> -->
      </div>
    </div>
    <div #viewportIndicator class="viewport-indicator"></div>
  </div>

  <ng-container *ngIf="!customMiniatureFooter; else customMiniatureFooter"></ng-container>
</div>